/* mobile menu */

$('.header__hamburger-toggler, .header__menuLink').click(function(){
    toggler();
});

function toggler() {
    $('.header__hamburger').toggleClass('header__hamburger--open');
    $('html, body').toggleClass('blocked');
    $('.header__nav').toggleClass('header__nav--visible');
}